import React, { Fragment } from 'react'

import type { PopUpButtonField } from '@/payload-types'

import { FormBlock } from '@/ui/blocks/Form/Component'
import { TypedLocale } from 'payload'
import { ContentBlock } from '@/ui/blocks/Content/Component'

const blockComponents = {
  formBlock: FormBlock,
  content: ContentBlock,
}

export const RenderPopUpBlocks: React.FC<{
  blocks: PopUpButtonField['layout']
  locale: TypedLocale
}> = (props) => {
  const { blocks, locale } = props

  const hasBlocks = blocks && Array.isArray(blocks) && blocks.length > 0

  if (hasBlocks) {
    return (
      <Fragment>
        {blocks.map((block, index) => {
          const { blockType } = block

          if (blockType && blockType in blockComponents) {
            const Block = blockComponents[blockType]

            if (Block) {
              return (
                <div className="mt-6" key={index}>
                  {/* @ts-expect-error there may be some mismatch between the expected types here */}
                  <Block {...block} disableInnerContainer locale={locale} formKey={block.id} isModal={true} />
                </div>
              )
            }
          }
          return null
        })}
      </Fragment>
    )
  }

  return null
}
